import { useQuery, type QueryClient } from '@tanstack/react-query';
import type { Tag } from '@tally/shared';
import { tagsApi, tripsApi } from '@/services/api';

export function useTags(): Tag[] {
  const { data } = useQuery({ queryKey: ['tags'], queryFn: () => tagsApi.list() });
  return data?.data ?? [];
}

export interface TripOption {
  id: string;
  name: string;
  startDate: string;
}

export function useTripOptions(): TripOption[] {
  const { data } = useQuery({ queryKey: ['trips', 'options'], queryFn: () => tripsApi.list({ pageSize: '200' }) });
  return data?.data?.items ?? [];
}

export function tripLabel(t: TripOption): string {
  return `${t.name}${t.startDate ? ` (${String(t.startDate).slice(0, 7)})` : ''}`;
}

/** Everything that shows which trip or tags an expense has. */
export function invalidateExpenseQueries(queryClient: QueryClient): void {
  for (const key of ['transactions', 'transactions-summary', 'trip-transactions', 'trips', 'trip', 'tags', 'dashboard']) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
}
